import {ModuleController} from "../../../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../../../infrastructure/domain-services/base-managed-service";
import {MatchEventsModuleConfig} from "./match-events.module-config";
import {MatchEventsModuleStore} from "./match-events-module.store";
import {MatchEventsModuleHandlers} from "./handlers/match-events-module.handlers";

export class MatchEventsModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, MatchEventsModuleConfig, MatchEventsModuleStore, MatchEventsModuleHandlers];
}
